export class GitIntegration {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": "uuid"
        },
        {
            "name": "provider",
            "baseName": "provider",
            "type": "GitProvider",
            "format": ""
        },
        {
            "name": "providerInstallationId",
            "baseName": "providerInstallationId",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountLogin",
            "baseName": "accountLogin",
            "type": "string",
            "format": ""
        },
        {
            "name": "accountType",
            "baseName": "accountType",
            "type": "GitAccountType",
            "format": ""
        },
        {
            "name": "status",
            "baseName": "status",
            "type": "GitIntegrationStatus",
            "format": ""
        },
        {
            "name": "manageUrl",
            "baseName": "manageUrl",
            "type": "string",
            "format": ""
        },
        {
            "name": "createdAt",
            "baseName": "createdAt",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "lastVerifiedAt",
            "baseName": "lastVerifiedAt",
            "type": "Date",
            "format": "date-time"
        }
    ];
    static getAttributeTypeMap() {
        return GitIntegration.attributeTypeMap;
    }
    constructor() {
    }
}
